import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

const ExternalRedirect: React.FC = () => {
  useEffect(() => {
    // open the LMS in a brand-new tab
    window.open(
      "https://elearning.costech.or.tz",
      "_blank",
      "noopener,noreferrer"
    );
  }, []);

  // send the current tab back to your landing page (or wherever you prefer)
  return <Navigate to="/" replace />;
};

export default ExternalRedirect;
